import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-barre-commande',
  templateUrl: './barre-commande.component.html',
  styleUrls: ['./barre-commande.component.css']
})
export class BarreCommandeComponent {
  @Output() rechercheChange = new EventEmitter<string>();
  @Output() categorieChange = new EventEmitter<string>();
  @Output() triChange = new EventEmitter<string>();
  
  recherche = '';
  categorie = '';
  tri = 'featured';

  onRechercheChange() {
    this.rechercheChange.emit(this.recherche);
  }

  onCategorieChange(categorie: string) {
    this.categorie = categorie;
    this.categorieChange.emit(categorie);
  }

  onTriChange(tri: string) {
    this.tri = tri;
    this.triChange.emit(tri);
  }
}

